module.exports = __webpack_public_path__ + "img/rad-conv-gen-3.c1b9606c.png";